module.exports = __webpack_public_path__ + "img/Folded_Paper-contact-banner-mobile.96473e68.svg";